export default "__VITE_ASSET__CXUyjqN3__"